import { css } from 'styled-components'

/**
 * Styles applied when the app is in headless mode (opened in mobile app webview).
 * Disables text selection to make the experience feel more native,
 * but preserves it for input fields where users need to interact with text.
 * Also disables long-press context menu on links to prevent iOS/Android callout menus.
 */
const HeadlessModeStyles = css`
  body.headless-mode {
    /* Disable text selection globally when in headless mode */
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    
    /* Re-enable text selection for input fields and textareas */
    input,
    textarea,
    [contenteditable="true"] {
      user-select: text;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
    }

    /* Disable long-press context menu on links in iOS/Android webviews */
    a {
      -webkit-touch-callout: none; /* iOS Safari - prevents long-press callout */
      -webkit-user-select: none;   /* iOS Safari */
      -moz-user-select: none;      /* Firefox */
      -ms-user-select: none;       /* IE/Edge */
      user-select: none;           /* Standard - for Android Chrome webview */
    }

    a:active,
    a:focus {
      outline: none; /* Remove focus outline on active links */
    }
  }
`

export default HeadlessModeStyles
